var $fa2ad4b5fd9fa2f1$exports = {};
class $fa2ad4b5fd9fa2f1$var$SvgIconFromUrl extends HTMLElement {
    constructor(){
        super();
        this.requestVersion = 0;
    }
    static get observedAttributes() {
        return [
            'src'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name !== 'src' || newValue === oldValue) return;
        this.fetchAndRender(newValue || '');
    }
    async fetchAndRender(url) {
        const requestVersion = ++this.requestVersion;
        if (!url) {
            this.innerHTML = '';
            return;
        }
        try {
            const response = await fetch(url);
            if (!response.ok) return;
            const svgText = await response.text();
            if (requestVersion !== this.requestVersion) return;
            this.innerHTML = svgText;
            const svg = this.querySelector('svg');
            if (svg && this.className) svg.classList.add(...this.className.split(' ').filter(Boolean));
        } catch  {
        // silently fail — Elm renders a fallback icon
        }
    }
}
customElements.define('svg-icon-from-url', $fa2ad4b5fd9fa2f1$var$SvgIconFromUrl);


//# sourceMappingURL=project.2c41e697.js.map
